import React, { useEffect, useState } from "preact/compat";
import constants from "../constants";
import printService from '../service/printService';
import util, { getHomeLink, getPrintCartLink } from "../util";
import SelectDropdown from "./SelectDropdown";
import { EditOutlined, DeleteOutlined, LoadingOutlined, CloseCircleFilled, DownOutlined, ExclamationCircleFilled, CheckCircleFilled } from "@ant-design/icons";
import store from "../store";
import * as actions from "../actions";
import { Skeleton } from "antd";
import "antd/lib/skeleton/style/index.css";
import "../../scss/asidePrint.scss";
import Renderer from "../canvas/renderer";
import designService from "../service/designService";
import { logAddToCart, logRemoveFromCart } from "../analyticsUtil";

export default function AsidePrint({ view, onClose, designSize, pages, paperSize, designId, designName, memberId, locationId, setShowExitWarning, templateId, showMatchingDesignsModal, isMobileVersion }: any) {
  const [loading, setLoading] = useState(false);
  const [loadingQuantities, setLoadingQuantities] = useState(false);
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [loadingAddMore, setLoadingAddMore] = useState(false);
  const [checkingMatchingDesigns, setCheckingMatchingDesigns] = useState(false);

  const [subview, setSubview] = useState('quote');

  const [draftOrder, setDraftOrder] = useState({} as any);

  let [paperType, setPaperType] = useState('') as any;
  const [paperTypes, setPaperTypes] = useState([] as any[]);

  let [pagination, setPagination] = useState('') as any;
  const [paginations, setPaginations] = useState([] as any[]);

  const [isOnlyPaperType, setIsOnlyPaperType] = useState(false);
  const [isOnlyPagination, setIsOnlyPagination] = useState(false);
  const [defaultQuantity, setDefaultQuantity] = useState('');

  const [quantity, setQuantity] = useState('') as any;
  const [quantities, setQuantities] = useState([] as any[]);

  const [price, setPrice] = useState(0) as any;
  const [products, setProducts] = useState([] as any[]);

  const [addItemToOrder, setAddItemToOrder] = useState(true);

  const [deleteLoadingIndex, setDeleteLoadingIndex] = useState(-1);
  const [gcStartingNumber, setGcStartingNumber] = useState('');
  const [gcEndingNumber, setGcEndingNumber] = useState('');

  const [editItem, setEditItem] = useState('');

  const [pagePrintError, setPagePrintError] = useState(false);

  const [phEdgesConfirmed, setPHEdgesConfirmed] = useState(false);
  const [phRedZoneConfirmed, setPHRedZoneConfirmed] = useState(false);
  const [phOtherConfirmed, setPHOtherConfirmed] = useState(false);

  const [subtotal, setSubtotal] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setLoading(true);

    Renderer.setSafeZone(true);

    let willBeError = false;
    if (pages !== 2 && (util.isTakeout(designSize) || util.isFoldedMenu(designSize) || util.isMenuMailer(designSize))) {
      setPagePrintError(true);
      willBeError = true;
    }
    if (pages >= 3 &&
      (util.isLoyaltyCard(designSize) || util.isCommentCard(designSize) || util.isRackCard(designSize) ||
        util.isGiftCertificate(designSize) || util.isBusinessCard(designSize) || util.isTableTent(designSize) ||
        util.isSandwichBoard(designSize))) {
      setPagePrintError(true);
      willBeError = true;
    }

    if (willBeError) {
      setLoading(false);
    } else {
      printService.getDraftOrder(locationId).then((resp) => {
        let editItemVar: any;
        if (resp.data) {
          resp.data.items = resp.data.items.reverse();
          setDraftOrder(resp.data);

          editItemVar = resp.data.items.find((it: any) => it.designId === designId);
          setEditItem(editItemVar);
        }

        if (util.isGiftCertificate(designSize) && editItemVar) {
          let start = editItemVar.gcStartingNumber;
          setGcStartingNumber(start);
          setGcEndingNumber(`${parseInt(start) - 1 + parseInt(editItemVar.quantity)}`);
        }

        let toBePages = pages;
        if (util.isTableTent(designSize)) {
          toBePages = 2;
        }
        if (util.isSandwichBoard(designSize)) {
          toBePages = 1;
        }

        printService.getSpecs(designSize, toBePages).then((resp) => {
          const toBePaperTypes = resp.data.paperTypes;

          // temporarily hide single use paper option
          /*if (toBePaperTypes.includes('single-use')) {
            toBePaperTypes.splice(toBePaperTypes.indexOf('single-use'), 1);
          }*/

          setPaperTypes(toBePaperTypes);
          if (toBePaperTypes.length === 1) {
            setPaperType(toBePaperTypes[0]);
            setIsOnlyPaperType(true);
          } else {
            const storedPaperType = store.getState().printPaperType;
            if (toBePaperTypes.includes(storedPaperType)) {
              setPaperType(storedPaperType);
            } else if (editItemVar && toBePaperTypes.includes(editItemVar.paperType)) {
              setPaperType(editItemVar.paperType);
            } else if (toBePaperTypes.includes(resp.data.defaultPaper)) {
              setPaperType(resp.data.defaultPaper);
            }
          }

          let toBePaginations = resp.data.paginations;
          if (util.isBusinessCard(designSize) || util.isLoyaltyCard(designSize) || util.isCommentCard(designSize)
            || util.isRackCard(designSize) || util.isGiftCertificate(designSize)) {
            if (pages === 1) {
              toBePaginations = ['single-sided'];
            } else {
              toBePaginations = ['double-sided'];
            }
          }
          setPaginations(toBePaginations);
          if (toBePaginations.length === 1) {
            setPagination(toBePaginations[0]);
            setIsOnlyPagination(true);
          } else {
            const storedPagination = store.getState().printPagination;
            if (toBePaginations.includes(storedPagination)) {
              setPagination(storedPagination);
            } else if (editItemVar) {
              setPagination(editItemVar.pagination);
            } else if (toBePaginations.includes(resp.data.defaultPagination)) {
              setPagination(resp.data.defaultPagination);
            }
          }

          if (resp.data.defaultQuantity) {
            setDefaultQuantity(resp.data.defaultQuantity);
          }

          setLoading(false);
        }).catch(err => {
          console.log(err);
          setLoading(false);
        })
      }).catch(err => {
        console.log(err);
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    if (!quantities.length) {
      loadQuantities()
    }
  }, [paperType, pagination]);

  function onPaperTypeChange(val: string) {
    store.dispatch(actions.setPrintPaperType(val));
    loadQuantities(val, '');
  }

  function onPaginationChange(val: string) {
    store.dispatch(actions.setPrintPagination(val));
    loadQuantities('', val);
  }

  function onQuantityChange(val: string) {
    store.dispatch(actions.setPrintQuantity(val));
  }

  function loadQuantities(paperTypeVal: string = '', paginationVal: string = '') {
    if (paperTypeVal) paperType = paperTypeVal;
    if (paginationVal) pagination = paginationVal;

    if (paperType && pagination) {
      setLoadingQuantities(true);

      let toBePaperSize = paperSize;
      if (util.isMenu(designSize) || util.isKidsMenu(designSize) || designSize === 'half-page-menu-wide-landscape' || util.isFlyer(designSize)) {
        // force portrait paper size
        let paperDims = toBePaperSize.split('x');
        if (parseFloat(paperDims[0]) > parseFloat(paperDims[1])) {
          toBePaperSize = `${paperDims[1]}x${paperDims[0]}`;
        }
      } else if (util.isBusinessCard(designSize) || util.isLoyaltyCard(designSize) || util.isSticker(designSize) || util.isLabel(designSize)) {
        // force landscape paper size
        let paperDims = toBePaperSize.split('x');
        if (parseFloat(paperDims[0]) < parseFloat(paperDims[1])) {
          toBePaperSize = `${paperDims[1]}x${paperDims[0]}`;
        }
      }

      let toBePages = pages;
      if (util.isTableTent(designSize)) {
        toBePages = 2;
      }
      if (util.isSandwichBoard(designSize) && paperType === 'a-frame') {
        toBePages = 1;
      }

      printService.getQuantities(designSize, toBePaperSize, toBePages, paperType, pagination).then((resp) => {
        setQuantities(resp.data.quantities);
        setProducts(resp.data.products);
        setQuantity('');

        let storedQuantity = store.getState().printQuantity;
        if (storedQuantity) {
          resp.data.quantities.forEach((q: any) => {
            if (q.quantity === storedQuantity.quantity && q.price === storedQuantity.price) {
              setQuantity(storedQuantity);
            }
          })
        } else if (editItem) {
          resp.data.quantities.forEach((q: any) => {
            if (q.quantity === (editItem as any).quantity) {
              setQuantity(q);
            }
          })
        } else if (defaultQuantity) {
          resp.data.quantities.forEach((q: any) => {
            if (q.quantity === defaultQuantity) {
              setQuantity(q);
            }
          })
        }
        setLoadingQuantities(false);
      })
    }
  }

  function goBack() {
    switch (subview) {
      case 'print-helper':
        setSubview('quote');
        break;
      case 'pre-checkout':
        setSubview('print-helper');
        break;
    }
  }

  function goToQuote() {
    setSubview('quote');
  }

  function goToPrintHelper() {
    if (!pagination || !paperType || !quantity || (util.isGiftCertificate(designSize) && gcStartingNumber === '')) return;
    setSubview('print-helper');
    util.nextTick(() => {
      if (!phEdgesConfirmed || !phOtherConfirmed || !phRedZoneConfirmed) {
        $('.ph-step.edges').removeClass('collapsed');
      }
    })
  }

  function goToPreCheckout() {
    if (phEdgesConfirmed && phRedZoneConfirmed && phOtherConfirmed) {
      setSubview('pre-checkout');
    }
  }

  function checkMatchingDesigns(url: string, callback: any) {
    if (url === getHomeLink() || !templateId) {
      callback();
    } else {
      setCheckingMatchingDesigns(true);

      designService.getTemplateSets(templateId).then(resp => {
        setCheckingMatchingDesigns(false);

        if (resp.data && resp.data.length > 1) {
          showMatchingDesignsModal()
        } else {
          callback();
        }
      }).catch(() => {
        setCheckingMatchingDesigns(false);
      });
    }
  }

  function goToCheckout(url: string) {
    if (loadingAddMore || loadingCheckout) return;
    if (url.includes('checkout')) {
      setLoadingCheckout(true);
      url += '?fromTimber=true';
    } else {
      setLoadingAddMore(true);
    }

    if (editItem) {
      printService.removeItem(draftOrder.id, (editItem as any).id).then((resp) => {
        logRemoveFromCart(resp.data);
        let draftOrderId = resp.data && resp.data.id ? resp.data.id : '';
        continueCheckout(url, draftOrderId);
      })
    } else {
      let draftOrderId = draftOrder.id ? draftOrder.id : ''
      continueCheckout(url, draftOrderId);
    }
  }

  function continueCheckout(url: string, draftOrderId: string) {
    const qty = quantity.quantity
    const price = quantity.price
    const shippingFee = quantity.shippingFee

    let item = {
      designId,
      designName,
      'quantity': qty,
      price,
      shippingFee,
      pages,
      paperSize,
      paperType,
      pagination,
      designSize,
      products,
      gcStartingNumber: gcStartingNumber !== '' ? gcStartingNumber : 1,
    }

    let order: any;

    if (draftOrderId && addItemToOrder) {
      printService.addOrderItem(draftOrderId, item).then((resp) => {
        logAddToCart(resp.data);

        checkMatchingDesigns(url, () => {
          setShowExitWarning(false);
          window.location.href = url;
        })
      })
    } else if (draftOrderId && !addItemToOrder) {
      checkMatchingDesigns(url, () => {
        setShowExitWarning(false);
        window.location.href = url;
      })
    } else {
      order = {
        memberId,
        locationId,
        status: 'DRAFT',
        subtotal: price,
        shipping: shippingFee,
        total: price + shippingFee,
        items: [item],
        email: (window as any).data.member.email
      }

      printService.getLocationOrders(locationId).then((resp) => {
        if (resp.data.length > 0) {
          let mostRecent = resp.data[resp.data.length - 1];
          order.addressType = mostRecent.addressType;
          order.name = mostRecent.name;
          order.businessName = mostRecent.businessName;
          order.addressLine1 = mostRecent.addressLine1;
          order.addressLine2 = mostRecent.addressLine2;
          order.city = mostRecent.city;
          order.state = mostRecent.state;
          order.zip = mostRecent.zip;
          order.phone = mostRecent.phone;
        }

        printService.createOrder(order).then((resp) => {
          checkMatchingDesigns(url, () => {
            setShowExitWarning(false);
            window.location.href = url;
          })
        })
      })
    }
  }

  function getPaperTypeOptions() {
    let options: {}[] = [];

    paperTypes.forEach(i => {
      options.push(util.getPaperTypeDescription(i, designSize));
    })

    return options
  }

  function getPaginationOptions() {
    let options: {}[] = [];

    paginations.forEach(i => {
      options.push(util.getPaginationDescription(i, designSize));
    })

    return options
  }

  function getQuantityOptions() {
    let options: {}[] = [];

    for (let i = 0; i < quantities.length; i++) {
      const quantity = quantities[i];
      const option = {
        value: quantity,
        title: quantity.quantity,
        description: <>
          <span className="price-per-quantity">${quantity.pricePerQuantity.toFixed(2)} per copy</span>
          <span className="price">${quantity.price.toFixed(2)}</span>
        </>
      };

      options.push(option);
    }

    return options
  }

  function getQuantityDescription(quantity: any) {
    if (!quantity) return '';

    return {
      value: quantity.quantity,
      title: <>
        <span className="copies">{quantity.quantity} {parseInt(quantity.quantity) === 1 ? 'copy' : 'copies'}</span>
        <span className="price">${quantity.price.toFixed(2)}</span>
      </>,
      description: <>
        <span className="price-per-quantity">${quantity.pricePerQuantity.toFixed(2)} per copy</span>
        <span className="price">${quantity.price.toFixed(2)}</span>
      </>
    }
  }

  function deleteItem(orderId: any, itemId: any, index: number) {
    setDeleteLoadingIndex(index);
    printService.removeItem(orderId, itemId).then(resp => {
      logRemoveFromCart(resp.data);

      if (resp.data) {
        setDraftOrder(resp.data)
      } else {
        setDraftOrder({});
        if (!addItemToOrder) {
          onClose();
        }
      }
      setDeleteLoadingIndex(-1);
    }).catch(err => {
      console.log('Error removing item from draft order');
      console.log(err);
      setDeleteLoadingIndex(-1);
    })
  }

  function removeCurrentItem() {
    if (!draftOrder.items || draftOrder.items.length === 0) {
      onClose();
    } else {
      setAddItemToOrder(false);
    }
  }

  function getPaginationTitle(pagination: any) {
    let paginationObj = util.getPaginationDescription(pagination, designSize) as any;
    return paginationObj.title;
  }

  function getPaperTypeTitle(paperType: any) {
    let paperTypeObj = util.getPaperTypeDescription(paperType, designSize) as any;
    return paperTypeObj.title;
  }

  function prettifyPaperSize(paperSize: string) {
    return paperSize.replace('x', ' x ');
  }

  function onGcNumberChange(ev: any) {
    let target = ev.target as any;
    let toSet = target.value;
    if (parseInt(toSet) < 0) {
      toSet = 0;
    }
    if (toSet) {
      toSet = Math.round(toSet);
    }
    setGcStartingNumber(toSet);
  }

  function onGcNumberBlur(ev: any) {
    let target = ev.target as any;
    if (target.value) {
      setGcEndingNumber(`${parseFloat(target.value) - 1 + quantity.quantity}`);
    } else {
      setGcEndingNumber('');
    }
  }

  useEffect(() => {
    if (gcStartingNumber !== '') {
      setGcEndingNumber(`${parseFloat(gcStartingNumber) - 1 + quantity.quantity}`);
    }
  }, [quantity])

  function chatAboutPrint() {
    (window as any).Intercom('showNewMessage');
  }

  const paperTypeFooter = <div className="footer"><div onClick={chatAboutPrint}>Chat with us to learn more about each paper type</div></div>

  const paginationFooter = <div className="footer">We do not offer binding. Back side of cover will be white. <div onClick={chatAboutPrint}>Chat with us to learn more about pagination options</div></div>

  function confirmPHStep(ev: any) {
    const $target = $(ev.target);
    const $stepObj = $target.closest('.ph-step');
    toggleCollapse($stepObj);

    if ($stepObj.hasClass('edges')) {
      setPHEdgesConfirmed(true);
      let nextStep = $('.ph-step.red-zone');
      openNextStep(nextStep);
    } else if ($stepObj.hasClass('red-zone')) {
      setPHRedZoneConfirmed(true);
      let nextStep = $('.ph-step.other');
      openNextStep(nextStep);
    } else if ($stepObj.hasClass('other')) {
      setPHOtherConfirmed(true);
    }
  }

  function openNextStep(nextStep: any) {
    nextStep.removeClass('collapsed');
    setTimeout(() => {
      let toScroll = nextStep.closest('.content.scroller');
      toScroll.animate({
        scrollTop: nextStep.offset().top
      }, 250);
    }, 300);
  }

  function toggleCollapseClick(ev: any) {
    const $target = $(ev.target);
    toggleCollapse($target.closest('.ph-step'));
  }

  function toggleCollapse(stepObj: any) {
    let currentlyCollapsed = stepObj.hasClass('collapsed');
    if (currentlyCollapsed) {
      stepObj.removeClass('collapsed');
      return;
    }
    util.nextTick(() => {
      stepObj.addClass('collapsed');
    })
  }

  useEffect(() => {
    const tempItems = editItem ? draftOrder.items.filter((it: any) => it.id !== (editItem as any).id) : draftOrder.items;
    let totalProducts = 0;
    let totalSubtotal = 0;
    let totalShipping = 0;

    if (tempItems && tempItems.length > 0) {
      tempItems.forEach((it: any) => {
        totalProducts += it.products.length;
        totalSubtotal += it.price;
        totalShipping += it.shippingFee;
      })
    }

    if (addItemToOrder) {
      totalProducts += products.length;
      totalSubtotal += quantity.price;
      totalShipping += quantity.shippingFee;
    }

    if (draftOrder.state === "AK") {
      totalShipping = totalSubtotal * 0.6

      if (totalShipping < 35.0) {
        totalShipping = 35.0
      }
    } else if (draftOrder.state === "HI") {
      totalShipping = totalSubtotal * 0.42

      if (totalShipping < 45.0) {
        totalShipping = 45.0
      }
    } else if (totalProducts >= 2) {
      totalShipping = totalShipping * 0.6;
    }
    
    setShipping(totalShipping);
    setSubtotal(totalSubtotal);
  }, [addItemToOrder, draftOrder, quantity, products])

  useEffect(() => {
    setTotal(subtotal + shipping);
  }, [subtotal, shipping])

  return (
    <div class="print-quote">
      <header>
        {subview == 'quote' && <span></span>}

        {subview != 'quote' &&
          <svg class="back-icon" onClick={goBack}>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"} />
          </svg>
        }

        <div class="steps">
          <div className={"step" + (subview == 'quote' || subview == 'print-helper' || subview == 'pre-checkout' ? ' selected' : '')}>
            <div>1</div>
          </div>
          <span class="dash">&#8212;</span>
          <div className={"step" + (subview == 'print-helper' || subview == 'pre-checkout' ? ' selected' : '')}>
            <div>2</div>
          </div>
          <span class="dash">&#8212;</span>
          <div className={"step" + (subview == 'pre-checkout' ? ' selected' : '')}>
            <div>3</div>
          </div>
        </div>

        <svg onClick={onClose}>
          <use xlinkHref="#app-icon-delete-close" />
        </svg>
      </header>

      <div class="content scroller">
        {subview === 'quote' &&
          <div class="quote">
            <h1>Select Print Options</h1>

            {loading ?
              <>
                <Skeleton.Input active />
                <Skeleton.Input className={"wide"} active />
                <Skeleton.Input className={"wide"} active />
                <Skeleton.Input className={"wide"} active />
              </>
              :
              <>
                <h4>
                  {util.getPrintCartSizeLabel(designSize)} &bull; {prettifyPaperSize(paperSize)} in<br />
                  {isOnlyPaperType && <>{getPaperTypeTitle(paperType)}<br /></>}
                  {pages} {pages === 1 ? 'page' : 'pages unbound'}{isOnlyPagination && <>, {getPaginationTitle(pagination).toLowerCase()}</>}
                </h4>

                {!isOnlyPaperType &&
                  <SelectDropdown
                    placeholder={"Paper Type"}
                    className={"paper-type-dropdown"}
                    disabled={pagePrintError}
                    selected={util.getPaperTypeDescription(paperType, designSize)}
                    elements={getPaperTypeOptions()}
                    onSelect={setPaperType}
                    callback={onPaperTypeChange}
                    dropdownFooter={paperTypeFooter}
                    isMobileVersion={isMobileVersion} />}

                {!isOnlyPagination &&
                  <SelectDropdown
                    placeholder={"Pagination"}
                    className={"pagination-dropdown"}
                    disabled={pagePrintError}
                    selected={util.getPaginationDescription(pagination, designSize)}
                    elements={getPaginationOptions()}
                    onSelect={setPagination}
                    callback={onPaginationChange}
                    dropdownFooter={paginationFooter}
                    isMobileVersion={isMobileVersion} />}

                <SelectDropdown
                  placeholder={"Quantity"}
                  className={"quantity-dropdown"}
                  disabled={!(paperType && pagination) || pagePrintError}
                  loading={loadingQuantities}
                  selected={getQuantityDescription(quantity)}
                  elements={getQuantityOptions()}
                  onSelect={setQuantity}
                  callback={onQuantityChange}
                  isMobileVersion={isMobileVersion} />

                {util.isGiftCertificate(designSize) && !pagePrintError &&
                  <div className="gc-numbering">
                    <p><span className="sequential">Sequential Numbering</span><br />
                      Enter starting number. Numbers will appear at the lower left corner, as shown below.</p>
                    <div className={`input-container ${quantity ? '' : 'disabled'}`}>
                      <input value={gcStartingNumber} type="number" onChange={(ev) => onGcNumberChange(ev)} onBlur={(ev) => onGcNumberBlur(ev)}></input>
                      {gcEndingNumber &&
                        <span>&mdash;&nbsp;&nbsp;{gcEndingNumber}</span>}
                    </div>
                    <div className="img-holder">
                      <img src="https://www.musthavemenus.com/imageservice/images/img/13/print/gift-certificate-serial-number.jpg" alt="_"></img>
                    </div>
                  </div>}

                {pagePrintError &&
                  <div className="pages-error">
                    <CloseCircleFilled />
                    <div>This design must be 2 pages to print double-sided</div>
                  </div>}
              </>
            }

            <footer>
              <a className={`btn primary ${!paperType || !pagination || !quantity || (util.isGiftCertificate(designSize) && gcStartingNumber === '') ? 'disabled' : ''}`} onClick={goToPrintHelper}>Continue</a>
              <a className={'btn primary2'} onClick={onClose}>Edit my design</a>
            </footer>
          </div>
        }

        {subview === 'print-helper' &&
          <div class="print-helper">
            <h1>Print Helper</h1>

            <p>
              Check that design is ready for print! <br />
              Review your design and Confirm
            </p>

            <div className={`ph-step collapsed edges ${phEdgesConfirmed ? 'confirmed' : ''}`}>
              <div className="collapse-toggle" onClick={(ev) => toggleCollapseClick(ev)}><DownOutlined /></div>
              <div className="step-name">
                <ExclamationCircleFilled />
                <CheckCircleFilled />
                <h2>Check Edges</h2>
              </div>
              <div className="step-content">
                <img src={constants.appPrefix + '/image/PH-CheckEdges.gif'} />
                <p>Be sure your images and background extend to each edge to avoid white edges.</p>
                <a className="btn primary" onClick={(ev) => confirmPHStep(ev)}>Confirm</a>
              </div>
            </div>

            <div className={`ph-step collapsed red-zone ${phRedZoneConfirmed ? 'confirmed' : ''}`}>
              <div className="collapse-toggle" onClick={(ev) => toggleCollapseClick(ev)}><DownOutlined /></div>
              <div className={`step-name ${!phEdgesConfirmed ? 'previous-step-not-confirmed' : ''}`}>
                <ExclamationCircleFilled />
                <CheckCircleFilled />
                <h2>Check Red Zone</h2>
              </div>
              <div className="step-content">
                <img src={constants.appPrefix + '/image/PH-CheckRedZone.gif'} />
                <p>Make sure your text does not go past the red safety zone around the design.</p>
                <a className="btn primary" onClick={(ev) => confirmPHStep(ev)}>Confirm</a>
              </div>
            </div>

            <div className={`ph-step collapsed other ${phOtherConfirmed ? 'confirmed' : ''}`}>
              <div className="collapse-toggle" onClick={(ev) => toggleCollapseClick(ev)}><DownOutlined /></div>
              <div className={`step-name ${!phRedZoneConfirmed ? 'previous-step-not-confirmed' : ''}`}>
                <ExclamationCircleFilled />
                <CheckCircleFilled />
                <h2>Other Checks</h2>
              </div>
              <div className="step-content">
                <img src={constants.appPrefix + '/image/PH-OtherChecks.gif'} />
                <p>- Blank Pages<br /><br />
                  - Overlapping Content<br /><br />
                  - Misspellings<br /><br />
                  - Font sizes smaller than 8 might be difficult to read in print
                </p>
                  
                <a className="btn primary" onClick={(ev) => confirmPHStep(ev)}>Confirm</a>
              </div>
            </div>

            <footer>
              {phEdgesConfirmed && phRedZoneConfirmed && phOtherConfirmed &&
                <a className={`btn primary`} onClick={goToPreCheckout}>Continue</a>
              }
              <a className={'btn primary2'} onClick={onClose}>Edit my design</a>
            </footer>
          </div>
        }

        {subview === 'pre-checkout' &&
          <div class="pre-checkout">
            <h1>Your Order</h1>

            <div className="summary">
              <div className="items">
                {addItemToOrder && <div className="item">
                  <div className="thumb">
                    <LoadingOutlined />
                    <div>
                      <img alt={designName} src={`${constants.RENDERER_DOMAIN}/design/thumbnail/${designId}?height=300`} />
                    </div>
                  </div>

                  <div className="info">
                    <div className="name">{designName}</div>
                    <div>{prettifyPaperSize(paperSize)} {util.getPrintCartSizeLabel(designSize)} - {pages} {pages === 1 ? 'page' : 'pages'}</div>
                    <div>{getPaperTypeTitle(paperType)}</div>
                    <div>{getPaginationTitle(pagination)}</div>
                    <div>{quantity.quantity} {parseInt(quantity.quantity) === 1 ? 'Copy' : 'Copies'}</div>
                    <div className="price">${quantity.price.toFixed(2)}</div>
                  </div>

                  <div className="edit-delete">
                    <div className="edit-btn" onClick={goToQuote}>
                      <EditOutlined />
                    </div>
                    <div className="delete-btn" onClick={removeCurrentItem}>
                      <DeleteOutlined />
                    </div>
                  </div>
                </div>}

                {draftOrder.id && draftOrder.items.map((item: any) => (
                  <div className={`item ${editItem && item.id === (editItem as any).id ? 'hidden' : ''}`}>
                    <div className="thumb">
                      <LoadingOutlined />
                      <div>
                        <img alt={item.designName} src={`${constants.RENDERER_DOMAIN}/design/thumbnail/${item.designId}?height=300`} />
                      </div>
                    </div>

                    <div className="info">
                      <div className="name no-cap">{item.designName}</div>
                      <div>{prettifyPaperSize(item.paperSize)} {util.getPrintCartSizeLabel(item.designSize)} - {item.pages} {item.pages === 1 ? 'page' : 'pages'}</div>
                      <div>{getPaperTypeTitle(item.paperType)}</div>
                      <div>{getPaginationTitle(item.pagination)}</div>
                      <div>{item.quantity} {parseInt(item.quantity) === 1 ? 'Copy' : 'Copies'}</div>
                      <div className="price">${item.price.toFixed(2)}</div>
                    </div>

                    <div className="edit-delete">
                      {draftOrder.items.indexOf(item) !== deleteLoadingIndex &&
                        <div className="delete-btn" onClick={() => deleteItem(draftOrder.id, item.id, draftOrder.items.indexOf(item))}>
                          <DeleteOutlined />
                        </div>}
                      {draftOrder.items.indexOf(item) === deleteLoadingIndex &&
                        <div className="delete-btn">
                          <LoadingOutlined />
                        </div>}
                    </div>
                  </div>
                ))}
              </div>

              <div className="totals">
                <div>Subtotal: <span class="price">${subtotal.toFixed(2)}</span></div>
                {/* <div>Shipping &amp; Processing: <span class="price">${shipping.toFixed(2)}</span></div> */}
                <div className="total">Total: <span class="price">${subtotal.toFixed(2)}</span></div>
              </div>
            </div>

            <footer>
              {!loadingCheckout && <a className={'btn primary'} onClick={() => goToCheckout(getPrintCartLink())}>Checkout</a>}
              {(loadingCheckout || checkingMatchingDesigns) && !loadingAddMore && <a className={'btn primary'}><LoadingOutlined /></a>}
              {!loadingAddMore && <a className={'add-more'} onClick={() => goToCheckout(getHomeLink())}>Add more designs &gt;</a>}
              {loadingAddMore && <a className={'add-more'}><LoadingOutlined /></a>}
            </footer>
          </div>
        }
      </div>
    </div>
  )
}
